/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type GlobalSettingEnum =
  (typeof GlobalSettingEnum)[keyof typeof GlobalSettingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GlobalSettingEnum = {
  AutoApprovalEnabled: 1,
  ConsecutiveHoursOfRestLast24Hours: 2,
  ConsecutiveHoursOfRestLast7Days: 3,
  MaxDrivingHoursLast7DaysAveragePer4Weeks: 4,
  MarginBetweenAssignmentsInMinutesWhenBooking: 5,
  DaysAheadToSpecifyFTAvailability: 6,
  MinDurationBetweenAssignmentArrivedAndTestComplete: 7,
  ZakraCustomerSurveyExpiryHours: 8,
  MaxDistanceFromGoalLocationInKms: 9,
  EstimatedStartTimePassedThreshold: 10,
  EstimatedEndTimePassedThreshold: 11,
  BookedToTimePassedThreshold: 12,
  UsersExcludedFromPlaceholderAssignmentRule: 13,
  MaxWorkingHoursPerDayForStandby: 14,
  MinAgeToFlagAsRiskVehicle: 15,
  MinMileageToFlagAsRiskVehicle: 16,
  CarTransportTruckDriverConsecutiveHoursOfRestLast24Hours: 17,
  CarTransportTruckConsecutiveHoursOfRestLast7Days: 18,
  CarTransportTruckMaxDrivingHoursLast7DaysAveragePer4Weeks: 19,
  CarTransportTruckWorkingHoursPerCalendarWeek: 20,
  CarTransportTruckTotalWorkingHoursPer2CalendarWeeks: 21,
  CarTransportTruckMaxConsecutiveWorkHoursWithoutBreak6To9Hours: 22,
  CarTransportTruckMaxDrivingHoursPer24Hours: 23,
  CarTransportTruckMaxDrivingHoursPerWeek: 24,
  CarTransportTruckMaxConsecutiveDrivingHoursWithoutBreak: 25,
  CarTransportTruckConsecutiveRestPerWeekEveryOtherWeek: 26,
  CarTransportTruckOnOffLoadingTime: 27,
  CarTransportTruckMaxDrivingHoursPerTwoWeeks: 28,
  UsersWithAccessToCarTransporTruckAssignments: 29,
  ActiveSpeedLimitServices: 30,
  CarTransportTruckMaxConsecutiveWorkHoursWithoutBreakMoreThan9Hours: 31,
  RegularFieldTesterBreakTimePer5Hours: 32,
  InternalDeliveryPaddingTimeAtLogistics: 33,
  CarTransportTruckOnOffLoadingTimePerCar: 34,
  CountyNamesCountedAsLargeCities: 35,
  UsersWithAccessToInEditStopOvers: 36,
  UsersWithAccessToShorterIntervalGPSTracking: 37,
  AutoApprovalFirstAssignmentOfDayStartTimeMinutesAllowance: 38,
  AutoApprovalLastAssignmentOfDayEndTimeMinutesAllowance: 39,
  AutoApprovalTrainAssignmentTimeMinutesAllowance: 40,
  AutoApprovalMaxAmountForManuallyUploadedExpenses: 41,
  AutoApprovalGeoTagVicinityAllowanceInMeters: 42,
  AutoApprovalMaxDeviationFromEstimatedDurationForWholeDayAssignmentsInMinutes: 43,
  AutoApprovalMaxAmountForAutomaticallyUploadedExpenses: 44,
  AutoApprovalMinimumAssignmentDurationInMinutes: 45,
  FullDayPlanningIgnoreRuleOnIntraday: 46,
  LiveETAPaddingPercent: 47,
  LiveETAUpdateIntervalMinutes: 48,
  LiveETADeviationThresholdMinutes: 49,
  GPSProximityThresholdMeters: 50,
  AutoApprovalFuelPricePerLiter: 51,
  AutoApprovalFuelCostTolerancePercent: 52,
  UsersWithAccessToTranslation: 53,
  UsersWithAccessToDayPlanning: 54,
  GPSEarlyStartDetectionEnabled: 55,
  UsersWithAccessToInvoiceExtras: 56,
  UsersWithAccessToDeviationReasons: 57,
  UsersRestrictedFromSettingOwnBreakTime: 58,
  BreakTimeTooMuchThresholdMinutes: 59,
  DefaultFuelConsumptionLitersPer100Km: 60,
  DefaultEnergyConsumptionKwhPer100Km: 61,
  DeliveryConditionQualityEmail: 62,
  UsersWithAccessToDeliveryConditionWizard: 63,
  VehicleWarningMessage_Supercar: 64,
  VehicleWarningMessage_Premium: 65,
  VehicleWarningMessage_TransportVehicle: 66,
  VehicleWarningMessage_Electric: 67,
  VehicleWarningMessage_HighMileage: 68,
  AutoApprovalBlockOnUnreadComments: 69,
  HRSpeedingReportGpsMissingThresholdPercent: 70,
  HRSpeedingReportGpsExpectedSamplingIntervalSeconds: 71,
  HRSpeedingReportEnabled: 72,
  BreakAddedToEstimatedDurationFromDate: 73,
  AutoApproveLastRunAt: 74,
  AutoApprovalUtdragenMaxHours: 75,
  GpsPauseRadiusMeters: 76,
  GpsPauseMinDurationMinutes: 77,
  ProlongedBusinessBaselineMinutesPerLeg: 78,
  UsersAllowedToSetOwnBreakTime: 79,
  AutoApprovalWholeDayDeviationMinutesPerAssignment: 80,
  RideBookingFilterEnabled: 81,
  RideBookingFilterClosedFromCounties: 82,
  RideBookingFilterHomeDeliveryWeekdayOpenUntil: 83,
  RideBookingFilterHomeDeliverySaturdayOpenUntil: 84,
  RideBookingFilterHomeDeliverySundayOpenUntil: 85,
  RideBookingFilterMaxAffectedDaysAhead: 86,
  RideBookingFilterHomeDeliveryWeekdayOpenFrom: 87,
  RideBookingFilterHomeDeliverySaturdayOpenFrom: 88,
  RideBookingFilterHomeDeliverySundayOpenFrom: 89,
  RideBookingFilterBlockAllHomeDeliveriesUntil: 90,
  UnavailableForDrivingQualityEmail: 91,
  UsersWithAccessToSharebox: 92,
  UsersWithAccessToRoutePlanning: 93,
  RoutePlanAbsoluteTbEnabled: 94,
  BlockWhenBreakCannotBePlanned: 95,
  UsersWithAccessToBreakPlanner: 96,
  BreakPlannerTrimExcessBreak: 97,
  WorkingTimeCapHoursPerFullTimeWeek: 98,
  UsersWithAccessToRiddermarkReporting: 99,
  CountyNamesWithFixedPurchaseLeadTime: 100,
  AutoApprovalLocalTransitHomeCountyMinAmount: 101,
  ProlongedDealVisitSoloPoolFallbackEnabled: 102,
  MaxDrivingHoursLast7DaysAveragePer4WeeksPartTime: 103,
  BreakPlannerCountPlannedGapsAsBreak: 104,
  RequireBookedToChangeReason: 105,
  UsersWithAccessToRoutePlanApply: 106,
  VehicleWarningMessage_LowRangeElectric: 107,
  CompanyIdsWithoutRebookingSuggestions: 108,
  RoutePlanFeedbackNameViewers: 109,
  RoutePlanFeedbackToastRecipients: 110,
  CompanyIdsAlwaysPlannedManually: 111,
  BreakPlannerThresholdMinutes: 112,
  RoutePlanFeedbackDismissalsBeforePause: 113,
  RoutePlanFeedbackPauseDays: 114,
  RoutePlanFeedbackToastExcluded: 115,
  UsersWithAccessToRoutePlanningSettings: 116,
  RoutePlanFacilityDeliveryHourlyRateSek: 117,
  RoutePlanRebookingWaitThresholdMinutes: 118,
  RoutePlanRebookingMaxShiftMinutes: 119,
  RoutePlanRebookingMinReductionMinutes: 120,
  RoutePlanMaxWalkMinutes: 121,
  RoutePlanFeedbackSampleSize: 122,
  RoutePlanMinCustomerVisitMinutes: 124,
  RoutePlanMinCustomerVisitCaseTypes: 125,
  ZipPrefixesExemptFromFixedPurchaseLeadTime: 126,
  AutobasUsername: 129,
  AutobasPassword: 130,
  AutobasUrl: 131,
} as const;
